import { Button, Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  EntityRelationWarning,
  EntitySwitch,
  hasCatalogProcessingErrors,
  hasRelationWarnings,
  isOrphan,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { EmptyState } from '@backstage/core-components';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { EntityKubernetesContent } from '@backstage/plugin-kubernetes';

export const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}><EntityOrphanWarning /></Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid item xs={12}><EntityRelationWarning /></Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}><EntityProcessingErrorsPanel /></Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

export const overviewTab = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}><EntityAboutCard variant="gridItem" /></Grid>
    <Grid item md={6} xs={12}><EntityCatalogGraphCard variant="gridItem" height={400} /></Grid>
    <Grid item md={4} xs={12}><EntityLinksCard /></Grid>
    <Grid item md={8} xs={12}><EntityHasSubcomponentsCard variant="gridItem" /></Grid>
  </Grid>
);

export const techdocsTab = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <ReportIssue />
    </TechDocsAddons>
  </EntityTechdocsContent>
);

export const cicdTab = (
  <EntitySwitch>
    <EntitySwitch.Case>
      <EmptyState
        title="CI/CD não disponível para esta entidade"
        missing="info"
        description="Adicione uma anotação ao seu componente para ativar o CI/CD. Saiba mais sobre anotações no Backstage clicando no botão abaixo."
        action={
          <Button
            variant="contained"
            color="primary"
            href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
          >
            Ler mais
          </Button>
        }
      />
    </EntitySwitch.Case>
  </EntitySwitch>
);

export const kubernetesTab = <EntityKubernetesContent />;

export const dependenciesTab = (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item md={6}><EntityDependsOnComponentsCard variant="gridItem" /></Grid>
    <Grid item md={6}><EntityDependsOnResourcesCard variant="gridItem" /></Grid>
  </Grid>
);
